const awsRumActionNames = {
    BACK: 'BACK',
    OPEN: 'OPEN',
    CLOSE: 'CLOSE',
    SKIP: 'SKIP',
    ADD_DEVICE: 'ADD_DEVICE',
    SIGN_IN: 'SIGN_IN',
    SIGN_UP: 'SIGN_UP',
    SIGN_OUT: 'SIGN_OUT',
    CONTINUE: 'CONTINUE',
    ACCEPT: 'ACCEPT',
    CHECK: 'CHECK',
    START: 'START',
    RETRY: 'RETRY',
    RESTART: 'RESTART',
    LEARN_MORE: 'LEARN_MORE',
    INSTALL: 'INSTALL',
    REMOVE: 'REMOVE',
    RESTORE: 'RESTORE',
    DECLINE: 'DECLINE',
    ON: 'ON',
    OFF: 'OFF',
    SYSTEM: 'SYSTEM',
    NEXT: 'NEXT',
    SAVE: 'SAVE',
    AUTO: 'AUTO',
    EXPLORE: 'EXPLORE',
    CONSUMABLES: 'CONSUMABLES',
    DEVICE_MANAGER: 'DEVICE_MANAGER',
    SCAN: 'SCAN',
    CANT_SEE: 'CANT_SEE',
    NONE: 'NONE',
    FIND_STORE: 'FIND_STORE',
    CONTACT_US: 'CONTACT_US',
    INFO: 'INFO',
    DEVICE: 'DEVICE',
    COPY: 'COPY',
    REWARD: 'REWARD',
    VIEW_ALL: 'VIEW_ALL',
    JOIN_TO_SWITCH_PROGRAM: 'JOIN_TO_SWITCH_PROGRAM',
    SELECT: 'SELECT',
    DESELECT: 'DESELECT',
    COMPLETE: 'COMPLETE',
    PROCEED: 'PROCEED',
    CONFIRM: 'CONFIRM',
    STORIES: 'STORIES',
    END: 'END',
    MILESTONE: 'MILESTONE',
    BADGE: 'BADGE',
    GO_TO_FIRST_SLIDE: 'GO_TO_FIRST_SLIDE',
    BLE: 'BLE',
    PHONE_NUMBER: 'PHONE_NUMBER',
    EMAIL: 'EMAIL',
    SLIDE: 'SLIDE',
    MODAL: 'MODAL',
    UP: 'UP',
    DOWN: 'DOWN',
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
    CHECK_STORES: 'CHECK_STORES',
    GO_TO_STORE: 'GO_TO_STORE',
    DONT_SHOW_AGAIN: 'DONT_SHOW_AGAIN',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
    LOAD_FAILED: 'LOAD_FAILED',
    SHARE: 'SHARE',
    LINK: 'LINK',
    FLAVOUR: 'FLAVOUR',
    ACCESSORY: 'ACCESSORY',
    PERSON: 'PERSON',
    PASSWORD: 'PASSWORD',
    PREFERENCE_CENTER: 'PREFERENCE_CENTER',
    THEME: 'THEME',
    LANGUAGE: 'LANGUAGE',
    NOTIFICATIONS: 'NOTIFICATIONS',
    CONVERSION: 'CONVERSION',
    EXPERIENCE: 'EXPERIENCE',
    SHORTCUT: 'SHORTCUT',
    VISITED: 'VISITED',
    SOCIALS: 'SOCIALS',
    INSTAGRAM: 'INSTAGRAM',
    FACEBOOK: 'FACEBOOK',
    REWARDS: 'REWARDS',
    NOTIFY: 'NOTIFY',
    TICKED: 'TICKED',
    PERSONALISE: 'PERSONALISE',
    VIEW_INSIGHTS: 'VIEW_INSIGHTS',
    REFRESH: 'REFRESH',
    GOT_IT: 'GOT_IT',
    OTHER: 'OTHER',
    SUBMIT: 'SUBMIT',
    STORED_NETWORK: 'STORED_NETWORK',
    SCANNED_NETWORK: 'SCANNED_NETWORK',
    LETS_GO: 'LETS_GO',
    REMOVE_NETWORK: 'REMOVE_NETWORK',
    UNDO_REMOVE_NETWORK: 'UNDO_REMOVE_NETWORK',
    TILE: 'TILE',
    LATER: 'LATER',
    SET_UP: 'SET_UP',
    GO_TO_SETTINGS: 'GO_TO_SETTINGS',
    USER_PROFILE: 'USER_PROFILE',
    SYNC_STATUS: 'SYNC_STATUS',
    CONNECTION_GUIDE: 'CONNECTION_GUIDE',
    AI_ASSISTANT: 'AI_ASSISTANT',
    COLLAPSE: 'COLLAPSE',
};

export default awsRumActionNames;
